import React from "react";
import { Stamp, Download, ExternalLink } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function fmtDate(iso) {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleString(undefined, { dateStyle: "long", timeStyle: "short" }); } catch { return iso; }
}

export default function TSASection({ result }) {
  if (!result?.tsa_timestamp) return null;
  const baseName = (result.file_name || "certificate").replace(/\.[^.]+$/, "");
  return (
    <div
      className="mt-8 p-5 rounded-lg"
      style={{ background: "var(--vault-bg)", border: "1px solid rgba(197,160,89,0.25)" }}
      data-testid="auth-tsa-section"
    >
      <div className="flex items-start gap-3 mb-4">
        <Stamp className="w-5 h-5 flex-shrink-0 mt-0.5" style={{ color: "var(--vault-gold)" }} />
        <div>
          <p className="overline" style={{ color: "var(--vault-gold)" }}>Trusted Timestamp · RFC 3161</p>
          <p className="text-sm text-[var(--vault-text-muted)] mt-1">
            Independently sealed by <span className="text-white">{result.tsa_provider}</span> on{" "}
            <span className="text-white" data-testid="auth-tsa-ts">{fmtDate(result.tsa_timestamp)}</span>.
            This signed token proves the document hash existed at this exact moment.
          </p>
        </div>
      </div>

      <div className="flex flex-wrap gap-2 mb-4">
        {result.tsa_token_url && (
          <a
            href={`${BACKEND_URL}${result.tsa_token_url}`}
            className="btn-ghost inline-flex items-center gap-2 px-3 py-2 rounded-md text-xs"
            data-testid="auth-download-tsr"
            download
          >
            <Download className="w-3.5 h-3.5" /> Download .tsr
          </a>
        )}
        {result.tsa_cert_url && (
          <a
            href={result.tsa_cert_url}
            target="_blank"
            rel="noreferrer"
            className="btn-ghost inline-flex items-center gap-2 px-3 py-2 rounded-md text-xs"
            data-testid="auth-tsa-cert"
          >
            <ExternalLink className="w-3.5 h-3.5" /> TSA certificate
          </a>
        )}
      </div>

      <details className="text-xs text-[var(--vault-text-muted)]">
        <summary className="cursor-pointer hover:text-white">How to verify independently with OpenSSL</summary>
        <pre className="mt-3 p-3 rounded font-mono-vault text-[11px] overflow-x-auto whitespace-pre-wrap"
          style={{ background: "rgba(0,0,0,0.4)", border: "1px solid var(--vault-border)", color: "var(--vault-text-muted)" }}>
{`# 1. Download the TSA root + signing certificates (one-time)
curl -sO https://www.freetsa.org/files/cacert.pem
curl -sO https://www.freetsa.org/files/tsa.crt

# 2. Download your timestamp token + the certificate file
#    (paste the certificate you received with the bottle as "certificate.pdf")

# 3. Verify
openssl ts -verify \\
  -data certificate.pdf \\
  -in ${baseName}.tsr \\
  -CAfile cacert.pem -untrusted tsa.crt

# Expected output: "Verification: OK"`}
        </pre>
      </details>
    </div>
  );
}
